import { convertStrapiSingleMediaOrArrayToMediaArray } from '@/lib/apiTypes';
import { EditorialErrorIdentifier } from '@/components/EditorialErrors/EditorialErrors';

const identifyMissingAltText: EditorialErrorIdentifier = ({ useSpecies }) => {
	const { species } = useSpecies;
	if (!species) return [];

	const mediaAlts: {
		speciesId: number;
		speciesName: string;
		srcUrl: string;
		altText: string;
		mediaType: 'image' | 'audio';
	}[] = [];

	// Look through the main image and images added to the descriptions
	species.data.forEach((species) => {
		// Get alt text from main image
		convertStrapiSingleMediaOrArrayToMediaArray(
			species.attributes.imageMain
		).forEach((media) => {
			if (!media.alternativeText) {
				mediaAlts.push({
					speciesId: species.id,
					speciesName: species.attributes.titleShort,
					srcUrl: media.url,
					altText: media?.alternativeText ?? '',
					mediaType: media.mime.split('/')[0] as 'image' | 'audio',
				});
			}
		});
		// Get alt text for every description
		Object.entries(species.attributes.speciesDescription).forEach(
			([, description]) => {
				if (typeof description === 'number') return;
				convertStrapiSingleMediaOrArrayToMediaArray(
					description.media
				).forEach((media) => {
					if (!media.alternativeText) {
						mediaAlts.push({
							speciesId: species.id,
							speciesName: species.attributes.titleShort,
							srcUrl: media.url,
							altText: media?.alternativeText ?? '',
							mediaType: media.mime.split('/')[0] as
								| 'image'
								| 'audio',
						});
					}
				});
			}
		);
	});

	// Check if every alt text is more than 4 words:
	return mediaAlts
		.filter((mediaItem) => mediaItem.altText.split(' ').length < 4)
		.map((mediaItem) =>
			mediaItem.mediaType === 'image'
				? {
					// Is image
					speciesId: mediaItem.speciesId,
					title: 'Afbeelding alternatieve tekst voor blinden en slechtzienden',
					description: (
						<>
							{mediaItem.speciesName} heeft een{' '}
							<a
								href={mediaItem.srcUrl}
								target="_blank"
								className="text-secondary underline"
							>
								foto
							</a>{' '}
							die niet kan worden begrepen door blinden en
							slechtzienden. Meer informatie bij{' '}
							<a
								href="https://inclusiefdesign.ntr.nl/redacteur/alt-tekst"
								target="_blank"
								className="text-secondary underline"
							>
								NTR Inclusief Design (alt tekst)
							</a>
							.
						</>
					),

				}
				: {
					// Is audio
					speciesId: mediaItem.speciesId,
					title: 'Geluid alternative tekst voor doven en slechthorenden',
					description: (
						<>
							{mediaItem.speciesName} heeft een{' '}
							<a
								href={mediaItem.srcUrl}
								target="_blank"
								className="text-secondary underline"
							>
								audiofragment
							</a>{' '}
							dat niet kan worden begrepen door doven en
							slechthorenden. Meer informatie bij{' '}
							<a
								href="https://inclusiefdesign.ntr.nl/redacteur/audio-video/geluidsbeschrijving"
								target="_blank"
								className="text-secondary underline"
							>
								NTR Inclusief Design (geluidsbeschrijving)
							</a>
							.
						</>
					),

				}
		);
};

export default identifyMissingAltText;
